const required = (value) => (value ? undefined : 'This field is required');

export default required;
